import React from "react";
import { BarChart, Bar, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExcelReason } from "../../functions/Report.ExportReson";
import { formatReason } from "../../utils/Report.Format";
import {
  BARCHART,
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEHEAD,
} from "../../../../utils/useStyle";
import DropdownReport from "../../report.dropdwn";
import { GenerateOptionsYear } from "../../../../components/functions/Functions";
import { optionsMonth } from "../common/ReportFilters";

const optionsYear = GenerateOptionsYear();

const DropdownMonthYear = ({ year, setYear, month, setMonth }) => {
  const isMonthDisabled = year.value === "ALL";
  return (
    <div className="flex space-x-2">
      <DropdownReport
        title={"ปี"}
        options={optionsYear}
        value={year}
        setValue={setYear}
        sideFunction={(val) => {
          if (val?.value === "ALL") {
            setMonth({
              label: "ทุกเดือน",
              value: "ALL",
            });
          }
        }}
      />
      <DropdownReport
        title={"เดือน"}
        options={optionsMonth}
        value={month}
        setValue={setMonth}
        disabled={isMonthDisabled}
      />
    </div>
  );
};

const ReportReason = ({ userDept }) => {
  const [loading, setLoading] = React.useState(false);
  const [month, setMonth] = React.useState({
    label: "ทุกเดือน",
    value: "ALL",
  });
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });

  const [data, setData] = React.useState({
    No_loanger_needed: 0,
    Death: 0,
    CLABSI: 0,
    Mechanical_problems: 0,
    Self_dislodged: 0,
    Dislodged_by_others: 0,
    Unresolved_occlusion: 0,
    Exit_site_infection: 0,
    other_reasons_for_discontinuation: 0,
    total: 0,
  });

  React.useEffect(() => {
    // Use backend API instead of frontend processing
    const fetchData = async () => {
      try {
        const response = await reportAPI.getReasonReport({
          year: String(year?.value),
          month: String(month?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching reason report:", error);
      }
    };
    fetchData();
  }, [year, month, userDept]);

  const listTable = [
    { name: "No longer needed", count: data?.No_loanger_needed },
    { name: "Death", count: data?.Death },
    { name: "CLABSI", count: data?.CLABSI },
    { name: "Mechanical problems", count: data?.Mechanical_problems },
    { name: "Self dislodged", count: data?.Self_dislodged },
    // { name: "Dislodged by others", count: data?.Dislodged_by_others },
    {
      name: "Unresolved occlusion",
      count: data?.Unresolved_occlusion,
    },
    { name: "Exit site infection", count: data?.Exit_site_infection },

    { name: "Other", count: data?.other_reasons_for_discontinuation },
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-gray-50 text-gray-700 text-sm px-2 py-1 rounded">
          {payload?.map((item, index) => {
            const count = item.value || 0;
            const percentage = ((count * 100) / data?.total).toFixed(1);
            return (
              <p key={index} className="label">
                {`count : ${count} (${percentage}%)`}
              </p>
            );
          })}
        </div>
      );
    }

    return null;
  };

  const renderCustomLabel = (props) => {
    const { x, y, width, height, value } = props;
    const percentage = ((value / data?.total) * 100).toFixed(1) + "%";
    const insideBarPosition = y + height / 2;

    return (
      <g>
        <text
          x={x + width / 2}
          y={insideBarPosition}
          fill="#111827"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {`${value} (${percentage})`}
        </text>
      </g>
    );
  };

  return (
    <div className="">
      <div className={``}>
        <div className="my-10">
          <>
            <div className={SCREENIPAD}>
              <div className={STYLEHEAD}>
                รายงานเหตุผลที่เลิกใช้สาย "{year.label}"
              </div>

              <div className={FLEXDROPDOWN}>
                <DropdownMonthYear
                  year={year}
                  setYear={setYear}
                  month={month}
                  setMonth={setMonth}
                />
                <ButtonExcel
                  onClick={() => {
                    ExcelReason(formatReason(data), year, setLoading);
                  }}
                  loading={loading}
                />
              </div>
            </div>
            <div>จำนวนสายทั้งหมด {data?.total}</div>
            <div className={BARCHART}>
              <BarChart
                width={750}
                height={300}
                data={listTable}
                margin={{
                  top: 20,
                  bottom: 2,
                }}
              >
                <CartesianGrid strokeDasharray="2 2" />
                {/* <XAxis dataKey="name" /> */}
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Bar label={renderCustomLabel} dataKey="count" fill="#FFCC66" />
              </BarChart>
            </div>
            <div className="grid grid-cols-8  ml-14 my-6 text-xs">
              <div className=" -rotate-45 transform-gpu text-center">
                No longer needed
              </div>
              <div className=" -rotate-45 transform-gpu text-center">Death</div>
              <div className=" -rotate-45 transform-gpu text-center">
                CLABSI
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Mechanical problems
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Dislodged
              </div>
              {/* <div className=" -rotate-45 transform-gpu text-center">
                Dislodged by others
              </div> */}
              <div className=" -rotate-45 transform-gpu text-center">
                Unresolved occlusion
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Exit site infection
              </div>
              <div className=" -rotate-45 transform-gpu text-center">Other</div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default ReportReason;
